export const hasImageExtension = text => /\.(jpg|jpeg|gif|png|bmp|svg|heic|avif|apng|webp)/i.test(text);
//# sourceMappingURL=has-image-extension.js.map